<template>
  <div class="app-details-container">
    <h2 class="app-details-heading">App Details</h2>
    <div class="app-details-row">
      <div class="app-details-form">
        <div class="form-group">
          <label>App Name</label>
          <input
            type="text"
            v-model="appName"
            class="form-control"
            placeholder="Enter App Name"
          />
        </div>
        <div v-if="selectedPlatforms !== 'web'" class="form-group">
          <label>App Version</label>
          <input
            type="text"
            v-model="appVersion"
            class="form-control"
            placeholder="Enter App Version"
          />
        </div>
        <!-- <div class="form-group">
          <label>Google API Key</label>
          <input
            type="text"
            v-model="googleClientId"
            class="form-control"
            placeholder="Enter Google API Key"
          />
        </div> -->
        <div v-if="selectedPlatforms === 'web'" class="form-group">
          <label>Tag Line</label>
          <input
            type="text"
            v-model="tagLine"
            class="form-control"
            placeholder="Enter Tag Line"
          />
          <div class="row mb-4" v-if="tagLineList && tagLineList.length">
            <b-col md="12"><p class="mb-2 font-weight-bold">AI Suggestions</p> </b-col>
            <b-col md="12">
              <ul v-if="tagLineList && tagLineList.length" class="list-unstyled">
                <li
                  class="font-weight-medium cursor-pointer mb-2"
                  v-for="(tagline, ind) in tagLineList"
                  :key="ind"
                  @click="selectTagLine(tagline)"
                >
                  <i class="fa fa-tag text-primary" font-scale="1.5" />
                  <span class="ml-2">{{ tagline }}</span>
                </li>
              </ul>
            </b-col>
          </div>
        </div>
        <div v-if="selectedPlatforms !== 'web'" class="form-group">
          <label>Package Name (Optional)</label>
          <input
            type="text"
            v-model="packageName"
            class="form-control"
            placeholder="Enter Package Name"
          />
        </div>
      </div>
      <b-col md="6">
        <div class="d-flex align-items-center justify-content-between mb-3">
          <div class="login-bg-label-row">
            <h4 class="login-bg-label">Login Screen Background</h4>
            <i id="button-2" class="fas fa-info-circle login-bg-tooltip"></i>
            <b-tooltip target="button-2" placement="top" triggers="hover">{{
              $t("Screen Bg Dimensions")
            }}</b-tooltip>
          </div>
        </div>
        <single-image
          height="200px"
          width="auto"
          @change="onLoginBgImgChange"
          :id="'loginBgImgid'"
          :url="loginBgImg"
          ref="loginBgImgId"
          label="Login Screen Background"
        ></single-image>
      </b-col>
    </div>
    <slot name="footer-button" :data="AppData"></slot>
  </div>
</template>

<script>
import SingleImage from "../../components/Common/Image.vue";
import { mapState } from "vuex";
import _ from "lodash";

export default {
  name: "AppDetails",
  data() {
    return {
      appName: "",
      appVersion: "",
      // googleClientId: "",
      packageName: "",
      tagLine: "",
    };
  },
  props: {
    selectedPlatform: {
      type: String,
      default: null,
    },
    loginBgImg: {
      type: String,
      default: null,
    },
    marketName: {
      type: Object,
      default: {},
    },
  },
  computed: {
    ...mapState({
      extendedList: (state) => state.tenant.extendedList,
      tagLineList: (state) => state.auth.tagLineList,
    }),
    AppData() {
      return {
        appName: this.appName,
        appVersion: this.appVersion,
        packageName: this.packageName,
        tagLine: this.tagLine,
      };
    },
    selectedPlatforms() {
      return this.selectedPlatform;
    },
  },
  components: {
    SingleImage,
  },
  methods: {
    onLoginBgImgChange(val) {
      this.$emit("update-login-bg-img", val);
    },
    // async fetchTaglines() {
    //   await this.$store.dispatch("auth/setTagLineList", {
    //     business_name: this.appName,
    //     industry_name: this.marketName && this.marketName.name,
    //   });
    // },
    selectTagLine(tagline) {
      this.tagLine = tagline;
    },
  },
  // created() {
  //   this.debouncedFetchTaglines = _.debounce(this.fetchTaglines, 600);
  // },
  watch: {
    selectedPlatform: {
      immediate: true,
      handler(newVal) {
        const platformConfig = this.extendedList.buildConfig[newVal];
        if (platformConfig) {
          this.appName = platformConfig.appName || "";
          this.tagLine = platformConfig.tagline || "";
        }
      },
    },
    // appName(newVal) {
    //   if (newVal && newVal.trim().length > 2) {
    //     this.debouncedFetchTaglines();
    //   }
    // },
  },
};
</script>

<style scoped>
.app-details-container {
  border: 1px solid #e3eaef;
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  width: 100%;
  box-sizing: border-box;
}
.app-details-row {
  display: flex;
  flex-wrap: wrap;
  gap: 40px;
  align-items: flex-start;
}
.app-details-form {
  flex: 1;
  min-width: 26px;
  width: 50%;
}
.app-details-heading {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 15px;
  color: #222;
}
.login-bg-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
}
.login-bg-label {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  color: #222;
}
.login-bg-tooltip {
  color: #727cf5;
  cursor: pointer;
  font-size: 18px;
  margin-left: 6px;
}
.form-group {
  margin-bottom: 12px;
}
.form-group label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 3px;
  display: block;
  color: #222;
}
.form-control {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  font-size: 15px;
  background: #fff;
  margin-top: 2px;
  transition: border-color 0.2s;
}
.form-control:focus {
  border-color: #2a8750;
  outline: none;
}
@media (max-width: 900px) {
  .app-details-row {
    flex-direction: column;
    gap: 22px;
  }
  .app-details-form {
    max-width: 100%;
  }
  .app-details-heading {
    font-size: 1.5rem;
    margin-bottom: 18px;
  }
}
@media (max-width: 580px) {
  .app-details-container {
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .stepper-btn {
    min-width: 120px;
  }
  .form-group {
    width: 190%;
  }
}
</style>
